import React, { useEffect, useState , useRef } from 'react';
import axios from 'axios';
import URL from '../constants/ServerUrl';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { convertDateToBS, convertDateToAD } from '../utils/convertDate';
import ReactToPrint from 'react-to-print';
import { formatDateInAD, formatDateInBS } from '../utils/formatDate';

const tableHead = [
  { label: 'Id' },
  { label: 'Name' },
  { label: 'Level' },
];

const AddCollection = ({ route }) => {

  const [totalAmt, setTotalAmt] = useState(0);
  const componentRef = useRef();
  const [rate, setRate] = useState(0);
  const [qty, setQty] = useState(null);
  const [fat, setFat] = useState(null);
  const [snf, setSnf] = useState(null);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const [filteredData, setFilteredData] = useState([]);
  const [focus, setFocus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dateString = searchParams.get('dateString');
  const currentDate = convertDateToAD(new Date());
  const [shift, setShift] = useState('Morning'); // Set default shift to 'morning'
  const token = localStorage.getItem('dairy-token');

  useEffect(() => {
    const fetchAllFarmers = async () => {
      try {
        if (username) {
          const farmers = await axios.get(`${URL}admin/${username}/farmer`);
          const farmersArray = farmers.data.map((farmer) => ({
            farmerName: farmer.farmerName,
            farmerId: farmer.farmerId,
            farmerLevel: farmer.farmerLevel,
          }));

          setData(farmersArray);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchAllFarmers();
  }, []);

  const addCollection = async (farmerId, farmerName, fixedRate) => {
    try {
      if (username && qty !== null) {
        setIsLoading(true);
        const rateResponse = await axios.get(

          `${URL}admin/${username}/ratelist/${farmerId}/rate?fat=${fat}&snf=${snf}`,{
            Authorization: `Bearer ${token}`,
          }
         
        );

        const rateData = rateResponse.data;
        console.log(dateString);

        if (rateData.rate) {
          setRate(rateData.rate);
          setTotalAmt(qty * rateData.rate);
          const collectionResponse = await axios.post(`${URL}admin/${username}/collection`, {
            shift: shift,
            qty: qty,
            fat: Number(fat),
            snf: Number(snf),
            farmerId: farmerId,
            farmerName: farmerName,
            collectionDate: dateString,
            amount: Number(qty * rateData.rate).toFixed(2),
            rate: Number(rateData.rate),
          },{
            Authorization: `Bearer ${token}`,
          });

          if (collectionResponse) {
            setIsLoading(false);
            setRate(0);
            setTotalAmt(0);
            setFat(null);
            setSnf(null);
            setQty(null);
            setSearch('');
            alert('Collection Added Successfully');
          }
        }
      }
    } catch (error) {
      setIsLoading(false);
      alert('Error adding collection');
      console.log(error.message);
    }
  };

  const handleSearchResultClick = (farmerId) => {
    setSearch('');
    setFilteredData(data.filter((item) => item.farmerId === farmerId));
    setFocus(true);
  };


  
  const Farmer = ({ farmerName, farmerId }) => (
    <button
      className="flex flex-col items-center justify-center p-4 border border-gray-300 rounded-md shadow-md hover:shadow-lg focus:outline-none"
      onClick={() => {
        setSearch(String(farmerName));
        setFilteredData(data.filter((item) => item.farmerId === farmerId));
        setFocus(false);
      }}
    >
      <div className="text-lg font-bold">{farmerId}</div>
      <div className="mt-2">{farmerName}</div>
    </button>
  );

  return (
<div className="p-4" ref={componentRef}>
  <input
    type="text"
    placeholder="Search by name or id"
    className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500"
    onChange={(text) => {
      setSearch(text.target.value);
      setQty(0);
      setFat(0);
      setSnf(0);
      setTotalAmt(0);
      setRate(0);
      if (text === '') {
        setFilteredData([]);
      }
    }}
    onFocus={() => setFocus(true)}
    value={search}
  />

  {focus && filteredData.length > 0 && search !== '' && (
    filteredData.map((item, index) => (
      <div className="my-4 p-4 border border-gray-300 rounded-md" key={index}>
        {/* Display farmer details */}
        <div className="mb-2">FARMER NAME: {item.farmerName}</div>
        <div className="mb-2">FARMER ID: {item.farmerId}</div>
        <div className="mb-1">
          Total Amount: {totalAmt} Rate: {rate}
        </div>

        <form className="flex flex-col space-y-4 mt-4">
  <input
    type="text"
    placeholder="Add Quantity"
    label="Quantity"
    className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500"
    value={qty !== null ? qty.toString() : ''}
    onChange={(text) => {
      setQty(text.target.value);
      setTotalAmt((text.target.value * rate).toFixed(2));
    }}
  />

  <input
    className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500"
    label="Fat"
    placeholder="Add Fat"
    value={fat > 0 ? fat.toString() : ''}
    onChange={(text) => setFat(text.target.value)}
  />

  <input
    className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500"
    label="SNF"
    placeholder="Add SNF"
    value={snf > 0 ? snf.toString() : ''}
    onChange={(text) => setSnf(text.target.value)}
  />

  {/* Button to add collection */}
  
</form>
<div className="flex justify-between items-center my-4">
  <button
    onClick={() => {
      if (!isLoading) {
        addCollection(item.farmerId, item.farmerName, item.fixedRate);
      }
    }}
    disabled={isLoading}
    className="bg-blue-500 text-white rounded-md disabled:opacity-50 px-3 py-3 mr-2"
  >
    {isLoading ? 'Adding...' : 'Add Collection'}
  </button>

  <div>
    <ReactToPrint
      trigger={() => (
        <button className="bg-green-500 text-white px-4 py-2 rounded-md mt-2 disabled:opacity-50">Print</button>
      )}
      content={() => componentRef.current}
    />
  </div>
</div>

      </div>
      
    ))
  )}

  {/* Display filtered farmers when no focus */}
  {focus && filteredData.length === 0 && search !== '' && (
    <div className="my-4 p-4 border border-gray-300 rounded-md">
      {data
        .filter(({ farmerName, farmerId }) => {
          const searchString = search.toLowerCase();
          const lowerCaseFarmerName = farmerName.toLowerCase();
          const stringFarmerId = String(farmerId);

          return (
            lowerCaseFarmerName.includes(searchString) ||
            stringFarmerId.includes(searchString)
          );
        })
        .map((item) => (
         

         
          <Farmer
            key={item.farmerId}
            farmerId={item.farmerId}
            farmerName={item.farmerName}
            
          />
       
        ))}
    </div>
  )}
</div>

  )
}



export default AddCollection